function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5938 13.5357V12.7031C22.5938 10.1223 21.6634 7.68933 19.9775 5.76672L20.4954 5.2489C20.77 4.97424 20.77 4.5293 20.4954 4.25464C18.2357 1.99493 15.188 0.75 12 0.75C8.81195 0.75 5.76434 1.99493 3.50464 4.25464C3.22998 4.5293 3.22998 4.97424 3.50464 5.2489L4.02264 5.76691C2.33661 7.68933 1.40625 10.1223 1.40625 12.7031V13.5357C0.5896 13.827 0 14.6001 0 15.5156V19.7344C0 20.8975 0.946289 21.8438 2.10938 21.8438H4.92188C5.31042 21.8438 5.625 21.5292 5.625 21.1406V14.1094C5.625 13.7208 5.31042 13.4062 4.92188 13.4062H2.8125V12.7031C2.8125 10.4594 3.62402 8.34467 5.09381 6.67621C5.79529 7.04114 6.71118 7.00763 7.37128 6.51031C10.0507 4.49286 13.9493 4.49286 16.6287 6.51031C17.0035 6.79248 17.4954 6.93054 17.939 6.93054C18.2748 6.93054 18.5964 6.82397 18.8985 6.6676C20.3732 8.33752 21.1875 10.4555 21.1875 12.7031V13.4062H19.0781C18.6896 13.4062 18.375 13.7208 18.375 14.1094V21.1406C18.375 21.5292 18.6896 21.8438 19.0781 21.8438H21.8906C23.0537 21.8438 24 20.8975 24 19.7344V15.5156C24 14.6001 23.4104 13.827 22.5938 13.5357Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2188 14.8125C15.8302 14.8125 15.5156 15.1271 15.5156 15.5156V19.7344C15.5156 20.1229 15.8302 20.4375 16.2188 20.4375C16.6073 20.4375 16.9219 20.1229 16.9219 19.7344V15.5156C16.9219 15.1271 16.6073 14.8125 16.2188 14.8125Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1094 22.5469V12.7031C14.1094 12.3146 13.7948 12 13.4062 12C13.0177 12 12.7031 12.3146 12.7031 12.7031V22.5469C12.7031 22.9354 13.0177 23.25 13.4062 23.25C13.7948 23.25 14.1094 22.9354 14.1094 22.5469Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2969 22.5469V12.7031C11.2969 12.3146 10.9823 12 10.5938 12C10.2052 12 9.89062 12.3146 9.89062 12.7031V22.5469C9.89062 22.9354 10.2052 23.25 10.5938 23.25C10.9823 23.25 11.2969 22.9354 11.2969 22.5469Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.48438 19.7344V15.5156C8.48438 15.1271 8.1698 14.8125 7.78125 14.8125C7.3927 14.8125 7.07812 15.1271 7.07812 15.5156V19.7344C7.07812 20.1229 7.3927 20.4375 7.78125 20.4375C8.1698 20.4375 8.48438 20.1229 8.48438 19.7344Z",
  fill: "white"
});

var SvgDj = function SvgDj(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDj, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dj.b5257b77.svg";
export { ForwardRef as ReactComponent };